import { z } from 'zod';
import { BaseValidations } from '@anytag/shared-validations';

export const TikTokSignupFormRegisteredSchema = z.object({
  countryId: z.string(),
  companyUrl: z.string(),
  companyName: z.string(),
  phoneNumber: BaseValidations.PhoneNumberSchema
});
